import { render } from "./FormItem.vue?vue&type=template&id=5124c7fc&ts=true"
import script from "./FormItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/form/FormItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5124c7fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5124c7fc', __exports__)) {
    api.reload('5124c7fc', __exports__)
  }
  
  module.hot.accept("./FormItem.vue?vue&type=template&id=5124c7fc&ts=true", () => {
    api.rerender('5124c7fc', render)
  })

}


export default __exports__